module.exports = __webpack_public_path__ + "img/icon-fav.061ded58.svg";